import { render, staticRenderFns } from "./MarketplaceStatuses.vue?vue&type=template&id=26186fae&"
import script from "./MarketplaceStatuses.vue?vue&type=script&lang=js&"
export * from "./MarketplaceStatuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports